var _style, _g, _circle, _defs, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalibration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199.1 199.1",
    style: {
      enableBackground: "new 0 0 199.1 199.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008FC2;}\n\t.st1{fill:#9DCEE3;}\n\t.st2{fill:#C2E5F0;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_2_);}\n\t.st5{fill:#E7AF52;}\n\t.st6{fill:#F4E592;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 99.5,
    cy: 99.5,
    r: 99.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.2,47c13.6,0,26.4,3,37.9,8.5c-15.4-27-44.3-45.1-77.6-45.1c-49.3,0-89.3,40-89.3,89.3 c0,35.7,21,66.5,51.3,80.8c-7.4-13-11.7-28.1-11.7-44.1C49.9,86.9,89.9,47,139.2,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.8,99.5c0-16.1-4.3-31.1-11.7-44.1C165.6,50,152.7,47,139.2,47c-49.3,0-89.3,40-89.3,89.3 c0,16.1,4.3,31.1,11.7,44.1c11.5,5.4,24.4,8.5,37.9,8.5C148.8,188.8,188.8,148.8,188.8,99.5z"
  })))), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 99.5,
    cy: 99.5,
    r: 53.7
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 99.5,
    cy: 99.5,
    r: 53.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M177.6,126.8c-9.1,0-13-16.1-17-33.2c-3.4-14.2-7.2-30.2-13.3-30.2s-9.9,16.1-13.3,30.2 c-4.1,17.1-7.9,33.2-17,33.2c-9.1,0-13-16.1-17-33.2c-3.4-14.2-7.2-30.2-13.3-30.2c-6.1,0-9.9,16.1-13.3,30.2 c-4.1,17.1-7.9,33.2-17,33.2c-9.1,0-13-16.1-17-33.2c-3.4-14.2-7.2-30.2-13.3-30.2c-1.1,0-1.9-0.9-1.9-1.9 c0-1.1,0.9-1.9,1.9-1.9c9.1,0,13,16.1,17,33.2c3.4,14.2,7.2,30.2,13.3,30.2c6.1,0,9.9-16.1,13.3-30.2 c4.1-17.1,7.9-33.2,17-33.2c9.1,0,13,16.1,17,33.2c3.4,14.2,7.2,30.2,13.3,30.2c6.1,0,9.9-16.1,13.3-30.2 c4.1-17.1,7.9-33.2,17-33.2c9.1,0,13,16.1,17,33.2c3.4,14.2,7.2,30.2,13.3,30.2c1.1,0,1.9,0.9,1.9,1.9 C179.6,125.9,178.7,126.8,177.6,126.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M201.9,113.1L201.9,113.1c-12.6,0-23.6-7.6-28.2-19.3c-1.6-4.6-5.1-8.1-9.6-9.7c-4-1.4-8.2-1.2-12,0.6 c-3.8,1.8-6.6,5-8,8.9c-3.1,7.9-9.4,14.2-17.2,17.3c-15.6,6.1-33.2-1.6-39.3-17.2c-1.6-4.6-5.1-8.1-9.6-9.7 c-8.2-2.9-17.1,1.4-20,9.6c-4.6,11.8-15.7,19.3-28.3,19.4h-7.2c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5h7.2 c10.5,0,19.7-6.3,23.6-16.1C57,81.3,68.8,75.6,79.6,79.4c6,2.1,10.6,6.7,12.7,12.7c2.4,6.2,7.2,11.2,13.4,13.9 c6.2,2.7,13,2.8,19.3,0.4c6.5-2.6,11.8-7.8,14.3-14.3c1.8-5.2,5.6-9.4,10.6-11.7c5-2.4,10.6-2.7,15.9-0.9 c6,2.1,10.6,6.7,12.7,12.7c3.8,9.7,13,16,23.5,16c1.4,0,2.5,1.1,2.5,2.5C204.4,112,203.3,113.1,201.9,113.1z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalibration);
export default __webpack_public_path__ + "static/media/calibration.c628a0eea7eb3dd6029b7d01d19e5450.svg";
export { ForwardRef as ReactComponent };